module.exports = __webpack_public_path__ + "img/db-placeholder.3ea61b9f.png";